import { render } from "./FavoriteChip.vue?vue&type=template&id=db294ae4&scoped=true"
import script from "./FavoriteChip.vue?vue&type=script&lang=js"
export * from "./FavoriteChip.vue?vue&type=script&lang=js"

import "./FavoriteChip.vue?vue&type=style&index=0&id=db294ae4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db294ae4"]])

export default __exports__